export const InternScoreFormFormat = function (blueprint, form_data = {}) {
  return {
    header_sq: header(form_data),
    content_sq: page(blueprint, form_data),
  };
}
function header(form_data) {
  return [

  ];
}

function page(blueprint, form_data) {
  return [
    {
      w: '100%', h: 50, text: '國立臺灣科技大學學生校外實習成績考評表',
      border_width: 0, font_size: 21, font_family: '標楷體',
    },

    { w: '18%', h: 30, text: '就讀系所' },
    { w: '82%', h: 30, text: form_data.department_id },

    { w: '18%', h: 30, text: '學號' },
    { w: '32%', h: 30, text: form_data.student_account },
    { w: '18%', h: 30, text: '姓名' },
    { w: '32%', h: 30, align: 'left', padding: 10, text: form_data.student_name },

    { w: '18%', h: 50, text: '實習單位' },
    { w: '32%', h: 50, text: form_data.internship },
    { w: '18%', h: 50, text: '部門別\n（上班班別）' },
    { w: '32%', h: 50, text: form_data.work_department },

    { w: '18%', h: 30, text: '實習評核期間' },
    { w: '82%', h: 30, text: `自 ${date_to_str(form_data.start_time)} 至 ${date_to_str(form_data.end_time)} 止` },

    { w: '50%', h: 70, text: '工作表現成績\n（百分計分與等第計分對應標準請參考附件）' },
    { w: '50%', h: 70, text: '學習報告成績\n（百分計分與等第計分對應標準請參考附件）' },

    { w: '35%', h: 40, text: '評　核　項　目'},
    { w: '15%', h: 40, text: '等第'},
    { w: '35%', h: 40, text: '評　核　項　目' },
    { w: '15%', h: 40, text: '等第'},

    { w: '35%', h: 30, text: '1.敬業精神'  ,align : 'left' , padding: 10},
    { w: '15%', h: 30, text: form_data.work_assess[0]},
    { w: '35%', h: 30, text: '1.報告結構內容'  ,align : 'left' , padding: 10},
    { w: '15%', h: 30, text: form_data.learn_assess[0]},

    { w: '35%', h: 30, text: '2.品質效率'  ,align : 'left' , padding: 10},
    { w: '15%', h: 30, text: form_data.work_assess[1]},
    { w: '35%', h: 30, text: '2.報告與實務工作關聯性'  ,align : 'left' , padding: 10},
    { w: '15%', h: 30, text: form_data.learn_assess[1]},

    { w: '35%', h: 30, text: '3.學習熱忱'  ,align : 'left' , padding: 10},
    { w: '15%', h: 30, text: form_data.work_assess[2]},
    { w: '35%', h: 30, text: '3.繳報告準時性'  ,align : 'left' , padding: 10},
    { w: '15%', h: 30, text: form_data.learn_assess[2]},

    { w: '35%', h: 30, text: '4.團隊合群、職業倫理' ,align : 'left' , padding: 10},
    { w: '15%', h: 30, text: form_data.work_assess[3]},
    { w: '35%', h: 30, text: '4.學習成果'  ,align : 'left' , padding: 10},
    { w: '15%', h: 30, text: form_data.learn_assess[3]},

    { w: '35%', h: 100, align : 'left', padding: 10, text: '5.其他：\n' + form_data.work_assess_other },
    { w: '15%', h: 100, text: form_data.work_assess_other_rank },
    { w: '35%', h: 100, align : 'left', padding: 10, text: '5.其他：\n' + form_data.learn_assess_other },
    { w: '15%', h: 100, text: form_data.learn_assess_other_rank },

    { w: '35%', h: 40, text: '實習機構評核成績', align: 'left', padding: 10 },
    { w: '15%', h: 40, text: form_data.company_score },
    { w: '35%', h: 40, text: '實習輔導教師評核成績', align: 'left', padding: 10 },
    { w: '15%', h: 40, text: form_data.teacher_score },

    { w: '50%', h: 100, baseline: 'top', align: 'left', padding: 10, text: '實習機構評語與建議：\n' + form_data.company_comments },
    { w: '50%', h: 100, baseline: 'top', align: 'left', padding: 10, text: '實習輔導教師評語與建議：\n' + form_data.teacher_comments },

    { w: '18%', h: 40, text: '實習機構評核者' },
    { w: '32%', h: 40, text: form_data.company_scorer },
    { w: '18%', h: 40, text: '實習輔導教師' },
    { w: '32%', h: 40, text: form_data.teacher_scorer },

    { w: '50%', h: 70, align: 'left', padding: 10, text: '校外實習委員會綜合實習機構及實習輔導教師之評核後，該生校外實習總成績' },
    { w: '50%', h: 70, text: form_data.overall_score },

    { w: '100%', h: 40, border_width: 0, padding: 10, align: 'left', text: `本案於 ${form_data.approved_date} 日經本系、所、科本學期第 ${form_data.committee_times} 次校外實習委員會通過` },

    { w: '100%', h: 40, border_width: 0, padding: 10, align: 'left', text: `單位主管：${form_data.dept_manager}` },

    { next_page: true },
    {
      w: '100%', h: 50, text: '百分計分與等第計分對應標準表',
      border_width: 0, font_size: 21, font_family: '標楷體',
    },
    { w: '15%', h: 60, text: '等第\n計分法' },
    { w: '15%', h: 60, text: '積分\n(GP值)' },
    { w: '15%', h: 60, text: '百分\n計分法' },
    { w: '15%', h: 60, text: '百分制分數\n區間中位數'},
    { w: '40#', h: 60, text: '備註' },

    ...rank_table(),
  ];
}

function rank_table() {
  return [
    ['A+' , '4.0' , '100 ~ 90' , '95' , '達成學習目標，且表現優異'],
    ['A'  , '4.0' , '89 ~ 85'  , '87' , '達成學習目標'],
    ['A-' , '3.7' , '84 ~ 80'  , '82' , '雖達成學習目標，但需再精進'],
    ['B+' , '3.3' , '79 ~ 77'  , '78' , '達成部分目標，且品質佳'],
    ['B'  , '3.0' , '76 ~ 73'  , '75' , '達成部分目標'],
    ['B-' , '2.7' , '72 ~ 70'  , '71' , '雖達成部分目標，但需要精進\n(研究生及格標準)'],
    ['C+' , '2.3' , '69 ~ 67'  , '68' , '達成最低目標'],
    ['C'  , '2.0' , '66 ~ 63'  , '65' , '雖達成最低目標，但需精進'],
    ['C-' , '1.7' , '62 ~ 60'  , '61' , '達成最低目標，但有重大缺失\n(大學部及格標準)'],
    ['D'  , '1.0' , '59 ~ 50'  , '55' , '雖未達最低目標，但可再研修'],
    ['E'  , '0.0' , '<50'      , '49' , '未達最低目標，不核予成績'],
    ['X'  , '-'   , '-'        , '-'  , '因故不予評分' ],
  ].map(rank_data => {
    return rank_data.map((str, index) => {
      return { w: index == 4 ? '40%' : '15%', h: 60, padding: 10, text: str };
    });
  }).flat();
}

// 通用
function other_str(value) {
  return (value ? '☑': '☐') + ' 其他：' + (value || "____________________");
}
function date_to_str(date_str) {
  if(!date_str) return ' - ';
  let nd = new Date(date_str);
  return `${nd.getFullYear() - 1911} 年 ${nd.getMonth() + 1} 月 ${nd.getDate()} 日`;
}
function date_to_str_yyyy_mm_dd(date_str) {
  if(!date_str) return ' - ';
  let nd = new Date(date_str);
  return [
    nd.getFullYear(),
    ("0" + (nd.getMonth() + 1)).substr(-2),
    ("0" + nd.getDate()).substr(-2),
  ].join('/');
}